import DataTable from '../../components/DataTable/DataTable';
import PageTitle from '../../components/PageTitle';
import { getTranslation } from '../../utils/functions';
import { Card } from '@hid-galaxy-ui/galaxy-react';
import { PageSize } from '../../constants/common';
import { IAppProps } from '../../App';
import useFetchTableData from '../../hooks/useFetchTableData';
import { ITableColumnConfig } from '../../components/DataTable/IDataTable';
import { getAccrRequestStatusTranslationKey } from '../../utils/status';
import ProfileIcon from '../../components/ProfileIcon/profileIcon';
import { MY_FORMS_COLUMNS } from './columns-definition';
import { fetchMyForms } from '../../services/app-user/app-user';
import { IMyFormsApiResponse } from './IMyForms';
import { useTranslation } from 'react-i18next';
import { getMyFormStatusTranslationKey } from './constants';

const MyForms = (props: IAppProps) => {
  const { toasts, setToasts } = props;

  const { data, isLoading, currentPage, fetchData, handlePageNumberClick, handlePageSizeChange } =
    useFetchTableData({
      apiFunction: fetchMyForms,
      initialParams: { pageNo: 0, pageSize: PageSize },
      toasts,
      setToasts,
    });

  const getColumns = () => {
    return MY_FORMS_COLUMNS.map((column) => {
      return {
        ...column,
        headerLabel: getTranslation(column.headerLabel),
      };
    });
  };

  const renderTitle = () => {
    return <PageTitle>{getTranslation('MY_FORMS')}</PageTitle>;
  };

   const transformMyFormsDataExternalToInternal = (data: IMyFormsApiResponse[]): IMyFormsApiResponse[] => {
    if (!data) return [];
    return data.map((item) => ({
      ...item,
      registerLabel: getTranslation('REGISTER'),
    }));
  };
  
  const extendStatusColumnConfig = (
    _column: ITableColumnConfig,
    rowData: any,
    _rowIndex: number,
    _columnIndex: number,
  ): any => {
    return getTranslation(getMyFormStatusTranslationKey(rowData?.status));
  };

  const MY_FORMS_CUSTOM_COLUMNS_CONFIG = {
    renderStatus: extendStatusColumnConfig,
  };

  return (
    <Card title={renderTitle()}>
      {
        <DataTable
          isPageLoading={isLoading}
          columnsConfig={getColumns()}
          data={transformMyFormsDataExternalToInternal(data?.items) || []}
          shouldRenderPagination={true}
          currentPage={currentPage}
          handlePageNumberClick={handlePageNumberClick}
          paginationData={data}
          onPageSizesClick={handlePageSizeChange}
          dependencies={MY_FORMS_CUSTOM_COLUMNS_CONFIG}
          dataKey="formDefId"
        />
      }
    </Card>
  );
};

export default MyForms;
